import { useApiClientStore } from '@stores/apiClientStore';
import { useThemeStore } from '@/stores/themeStore';
import { useTeamStore } from '@/stores/teamStore';
import { usePlayerStore } from '@/stores/playerStore';
import {
	MockCompetitionApiClient,
	MockChallengeApiClient,
	MockTeamApiClient,
	MockPlayerApiClient,
	MockSubmissionApiClient,
	MockEmptyApiClient,
	MockFileApiClient,
	MockJobApiClient,
	MockSubscriptionApiClient,
} from './themeEditorMockClients';
import { fixturePlayer, fixtureTeams } from './themeEditorFixtures';

export function setupThemeEditorPreview(): void
{
	const apiClientStore = useApiClientStore();

	// Inject mock clients for competition/challenge/team/player/submission
	apiClientStore._competitionApiClient = MockCompetitionApiClient as any;
	apiClientStore._backgroundCompetitionApiClient = MockCompetitionApiClient as any;
	apiClientStore._challengeApiClient = MockChallengeApiClient as any;
	apiClientStore._backgroundChallengeApiClient = MockChallengeApiClient as any;
	apiClientStore._teamApiClient = MockTeamApiClient as any;
	apiClientStore._backgroundTeamApiClient = MockTeamApiClient as any;
	apiClientStore._playerApiClient = MockPlayerApiClient as any;
	apiClientStore._backgroundPlayerApiClient = MockPlayerApiClient as any;
	apiClientStore._submissionApiClient = MockSubmissionApiClient as any;
	apiClientStore._backgroundSubmissionApiClient = MockSubmissionApiClient as any;

	// Inject empty/no-op clients for non-critical APIs
	apiClientStore._organizationApiClient = MockEmptyApiClient as any;
	apiClientStore._agreementApiClient = MockEmptyApiClient as any;
	apiClientStore._backgroundAgreementApiClient = MockEmptyApiClient as any;
	apiClientStore._subscriptionApiClient = MockSubscriptionApiClient as any;
	apiClientStore._fileApiClient = MockFileApiClient as any;
	apiClientStore._contentApiClient = MockEmptyApiClient as any;
	apiClientStore._backgroundContentApiClient = MockEmptyApiClient as any;
	apiClientStore._jobApiClient = MockJobApiClient as any;
	apiClientStore._catalogApiClient = MockEmptyApiClient as any;
	apiClientStore._backgroundCatalogApiClient = MockEmptyApiClient as any;
	apiClientStore._catalogFamilyApiClient = MockEmptyApiClient as any;
	apiClientStore._backgroundCatalogFamilyApiClient = MockEmptyApiClient as any;
	apiClientStore._catalogFamilySearchApiClient = MockEmptyApiClient as any;
	apiClientStore._backgroundCatalogFamilySearchApiClient = MockEmptyApiClient as any;
	apiClientStore._challengeEnvironmentApiClient = MockEmptyApiClient as any;
	apiClientStore._backgroundChallengeEnvironmentApiClient = MockEmptyApiClient as any;
	apiClientStore._libraryApiClient = MockEmptyApiClient as any;
	apiClientStore._backgroundLibraryApiClient = MockEmptyApiClient as any;
	apiClientStore._userApiClient = MockEmptyApiClient as any;
	apiClientStore._invitationApiClient = MockEmptyApiClient as any;

	// Bulk clients
	apiClientStore._bulkUserApiClient = MockEmptyApiClient as any;
	apiClientStore._bulkInvitationApiClient = MockEmptyApiClient as any;
	apiClientStore._bulkPlayerApiClient = MockEmptyApiClient as any;
	apiClientStore._bulkTeamApiClient = MockEmptyApiClient as any;
	apiClientStore._bulkLibraryApiClient = MockEmptyApiClient as any;
	apiClientStore._bulkChallengeApiClient = MockEmptyApiClient as any;

	// Leave _authenticationApiClient and _entitlementApiClient unset
	// so real clients are used for authentication and authorization

	// Pre-populate player and team stores so that fetchSubmissions
	// can match submissions to the current team immediately
	usePlayerStore().setCurrentPlayer(fixturePlayer);
	useTeamStore().setTeams(fixtureTeams);
	useTeamStore().setMyTeam(fixturePlayer.teamId);

	// Open the theme editor sidebar by default in preview mode
	useThemeStore().showThemeEditor = true;
}
